// extracted by mini-css-extract-plugin
export default {"content":"styles_content__TR-Of","body":"styles_body__JNcmq"};